<template>
  <el-select
    v-model="value"
    multiple
    filterable
    allow-create
    default-first-option
    popper-class="hide-select-dropdown"
    :reserve-keyword="false"
    placeholder="Choose tags for your article"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const value = ref<string[]>([]);
const options = [];
</script>
<style>
/* 隐藏下拉面板 */
.hide-select-dropdown {
  display: none !important;
}
</style>
